import { useMemo } from "react";
import { routes } from "../../../app/routes";
import { PermissionDefinitions } from "../../../security";
import { usePermission, useQueryParams, useUrlParams } from "../../../hooks";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";

export const LocationTopbar = (props: any) => {
  const id = useUrlParams("id");
  const { getQueryParam } = useQueryParams();
  const returnUrl = getQueryParam("returnurl");
  const canGetLocation = usePermission(PermissionDefinitions.location.edit());

  const submenuItems: TopbarMenuItem[] = useMemo((): TopbarMenuItem[] => {
    const items: TopbarMenuItem[] = [
      {
        label: "Back",
        icon: IconDefinitions.back,
        url: returnUrl ?? routes.location.index,
      },
      {
        label: "Details",
        icon: IconDefinitions.squareInfo,
        url: routes.location.details,
        activeMatch: routes.location.details,
        params: new Map([["id", id]]),
      },
      {
        label: "Address",
        icon: IconDefinitions.mapMarker,
        url: routes.location.address,
        activeMatch: routes.location.address,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      {
        label: "Providers",
        icon: IconDefinitions.hand,
        url: routes.location.provider.index,
        activeMatchExact: false,
        activeMatch: [
          routes.location.provider.index,
          routes.location.provider.details,
          routes.location.provider.services,
          routes.location.provider.schedule,
        ],
        params: new Map([["id", id]]),
      },
    ];

    if (canGetLocation) {
      items.push(
        {
          label: "Pricing",
          icon: IconDefinitions.moneyBill,
          url: routes.location.pricing,
          activeMatch: routes.location.pricing,
          activeMatchExact: true,
          params: new Map([["id", id]]),
        },
        {
          label: "Payments",
          icon: IconDefinitions.mapMarker,
          url: routes.location.payments,
          activeMatch: routes.location.payments,
          activeMatchExact: true,
          params: new Map([["id", id]]),
        },
        {
          label: "Closure",
          icon: IconDefinitions.mapMarker,
          url: routes.location.closure,
          activeMatch: routes.location.closure,
          activeMatchExact: true,
          params: new Map([["id", id]]),
        },
          
      );
    }

    return items;
  }, [id, canGetLocation, returnUrl]);

  return <TopbarSubmenu className="p-0" items={submenuItems}></TopbarSubmenu>;
};

export default LocationTopbar;

